import React, { useState, useEffect } from "react"
import { Button, OverlayTrigger, Popover } from "react-bootstrap"

import { isLTPM } from "../../../../../components/shared_components_registration"
import { withRunEventLabelState } from "../../../../../components/shared_components_registration"
import { ColorBoxWithLabel } from "../../GraphComponents/CrossHairLayer/PointDataOverlay"

export const LabelDetails = ({ eventType = {}, divStyle = {} }) => {
  if (!eventType?.name) {
    return <></>
  }

  return (
    <div style={divStyle}>
      {[
        ["Name", "name"],
        ["Description", "description"],
        ["Clarification", "clarification"],
        ["Start Condition", "start_condition"],
        ["End Condition", "end_condition"],
      ].map((d) => (
        <div key={`${eventType.name}${d[1]}`}>
          {eventType?.[d[1]] && (
            <div>
              <b>{d[0]}: </b>
              {eventType[d[1]]}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

const ToggleEventLayers = ({
  small = false,
  site = "",
  reactor = "",
  canToggleVisibility = true,
  selectEventLabel,
  runEventRegistration = [], // From RunLabelConfigProvider
  toggleRunEventVisibility, // From RunLabelConfigProvider
  toggleAllEventVisibility, // From RunLabelConfigProvider
}) => {
  const [initialRegistration, setInitialRegistration] = useState([])
  useEffect(() => {
    setInitialRegistration(
      runEventRegistration.map((event) => {
        return {
          ...event,
          detailsVisible: false,
          isAvailable: !site || !reactor || (event?.applicable_reactors?.[site] || []).includes(reactor),
        }
      }),
    )
  }, [site, reactor, runEventRegistration])

  const [selectAll, setSelectAll] = useState(true)
  const [searchTerm, setSearchTerm] = useState("")

  const toggleSelectAll = (e) => {
    setSelectAll(e.target.checked)
    toggleAllEventVisibility(e.target.checked)
  }

  const [validEventOptions, setValidEventOptions] = useState([])
  useEffect(() => {
    setValidEventOptions(
      initialRegistration.filter(
        (event) =>
          !searchTerm ||
          event.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          event.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
          event.clarification.toLowerCase().includes(searchTerm.toLowerCase()) ||
          event.start_condition.toLowerCase().includes(searchTerm.toLowerCase()) ||
          event.end_condition.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    )
  }, [initialRegistration, searchTerm])

  const updateDetailVisibility = (event_id) => {
    setValidEventOptions(
      validEventOptions.map((e) => {
        if (e.id === event_id) {
          return {
            ...e,
            detailsVisible: !e.detailsVisible,
          }
        } else {
          return e
        }
      }),
    )
  }

  const title = canToggleVisibility ? "Toggle Event Label Visibility" : "Run Event Label Details"
  const [showPopover, setShowPopover] = useState()

  return (
    <>
      {!isLTPM && (
        <OverlayTrigger
          trigger={"click"}
          placement={"bottom"}
          rootClose
          overlay={
            <Popover
              id="toggle_event_layers"
              onClick={(e) => {
                e.stopPropagation()
              }}
            >
              <Popover.Header as={"h3"}>{title}</Popover.Header>
              <Popover.Body>
                <div>
                  <input
                    type={"text"}
                    style={{ width: "100%" }}
                    value={searchTerm || ""}
                    placeholder={"Search Events..."}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  {canToggleVisibility && (
                    <div style={{ display: "flex" }}>
                      <input type={"checkbox"} checked={selectAll} onChange={(e) => toggleSelectAll(e)} />
                      :&nbsp;
                      <span>Show All</span>
                    </div>
                  )}
                  <hr style={{ margin: "2px 0" }} />
                  <div style={{ overflowY: "scroll", maxHeight: "300px" }}>
                    {validEventOptions.map((event) => (
                      <div key={`${event.name}Visibility`}>
                        <div
                          className={"row"}
                          style={{ margin: "0", padding: "0", display: "flex", alignItems: "center" }}
                        >
                          <div className={"col-1"} style={{ margin: "0", padding: "0" }}>
                            {canToggleVisibility ? (
                              <>
                                <input
                                  type={"checkbox"}
                                  checked={event.show}
                                  onChange={() => toggleRunEventVisibility(event.id)}
                                />
                                :
                              </>
                            ) : !event.isAvailable ? (
                              <Button
                                variant={"outline-primary"}
                                className={`${small ? " btn-sm" : ""}`}
                                title={`Label unavailable for ${site}/${reactor}`}
                                style={{ zIndex: "100" }}
                                disabled={true}
                              >
                                <span className={"fa fa-times"} aria-hidden={"true"} />
                              </Button>
                            ) : (
                              selectEventLabel && (
                                <Button
                                  variant={"outline-primary"}
                                  className={"btn-sm"}
                                  title={"Choose Event Label"}
                                  style={{ zIndex: "100" }}
                                  onClick={() => {
                                    selectEventLabel(event)
                                    document.body.click() // To close popover on button click
                                  }}
                                >
                                  <span className={"fa fa-check-circle-o"} aria-hidden={"true"} />
                                </Button>
                              )
                            )}
                          </div>
                          <div
                            className={"col-11"}
                            onClick={() => updateDetailVisibility(event.id)}
                            style={{ margin: "0", padding: "0", paddingTop: "3px", cursor: "pointer" }}
                          >
                            <ColorBoxWithLabel
                              color={event.default_color}
                              opacity={event.opacity}
                              text={event.name}
                            />
                            &nbsp;
                            <span className={`fa fa-caret-${event.detailsVisible ? "up" : "down"}`} />
                          </div>
                        </div>
                        {event.detailsVisible && (
                          <div className={"row"} style={{ margin: "0", padding: "0" }}>
                            <div className={"col-1"} style={{ margin: "0", padding: "0" }}></div>
                            <div
                              className={"col-11 solid-grey-border"}
                              style={{
                                margin: "0",
                                padding: "10px",
                                backgroundColor: "var(--lanzalake-grey-light-2)",
                                fontSize: "90%",
                                borderRadius: "5px",
                              }}
                            >
                              <LabelDetails eventType={event} />
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </Popover.Body>
            </Popover>
          }
        >
          <Button
            variant={"outline-primary"}
            className={`${small ? " btn-sm" : ""}`}
            title={title}
            style={{ zIndex: "100" }}
            onClick={(ev) => ev.stopPropagation()}
            disabled={validEventOptions.length === 0}
          >
            <span className={canToggleVisibility ? "fa fa-eye-slash" : "fa fa-book"} aria-hidden={"true"} />
          </Button>
        </OverlayTrigger>
      )}
    </>
  )
}

export default withRunEventLabelState(ToggleEventLayers)
